import { TypeAnimation } from 'react-type-animation';

export default function HeroSection() {
    return (
        <div
            className="paragraph paragraph--type--ixm-blocks-hero-banner paragraph--view-mode--default hero-banner hero-banner__style-3 py-4 py-lg-8 bg-gray-200 mb-5">
            <div className="container">
                <div className="row justify-content-between align-items-center">
                    <div className="mh-column col-12 col-lg-6 z-1">
                        <h1 className="text-4xl font-semibold pb-4">
                            <strong className="brand-color">
                                <TypeAnimation
                                    sequence={[
                                        'Launch a Startup',
                                        3000,
                                        'Ship Real Products',
                                        3000,
                                        'Lead Your First Team',
                                        3000,
                                        'Build This Summer',
                                        3000,
                                    ]}
                                    wrapper="span"
                                    speed={200}
                                    style={{ fontSize: '1.8em', display: 'inline-block' }}
                                    repeat={Infinity}
                                />
                            </strong>
                            <div>
                                <strong className="text-6xl">at Extern Academy</strong>
                            </div>
                        </h1>
                        <div className="font-semibold">
                            <p>
                                Extern Academy brings driven upperclassmen together to form a brand-new startup and build, launch, and lead a product all the way to Deployment Day.
                            </p>
                        </div>
                        <div className="d-none d-lg-flex mt-3 flex-wrap gap-3">
                            <a href="#programs"
                               className="btn btn-lg btn-primary d-inline-flex align-items-center gap-2 font-semibold">
                                See Programs <span className="material-symbols-outlined">arrow_forward</span>
                            </a>
                        </div>
                    </div>
                    <div className="col-12 col-lg-5 col-lg-offset-1 mt-lg-n10 mt-3 position-relative z-0">
                        <img className="img-fluid hero__image-1 mt-12"
                             src="https://firebasestorage.googleapis.com/v0/b/extern-academy.firebasestorage.app/o/website%2Fimages%2Fcustom%2Fplanning.webp?alt=media&token=a149cc36-388a-425c-b253-06da7a1438e8"
                             alt="Students planning their startup"/>
                        {/*<img className="img-fluid hero__image-2 d-none d-lg-block mt-4" width="50%"*/}
                        {/*     src="https://www.knoxnews.com/gcdn/presto/2022/05/23/PKNS/e8cd5c14-56b9-4375-9fe1-b2d38a82e839-TechStars_0298.jpg?width=1320&height=990&fit=crop&format=pjpg&auto=webp"*/}
                        {/*     alt="Startup team at work"/>*/}
                        <img className="img-fluid hero__image-3 d-none d-lg-block" height="10%" width="50%"
                             src="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/misc/7352d5_5212cad501a445edaa56ad8067ef38bb-mv2.webp"
                             alt="Students collaborating"/>
                    </div>
                    <div className="col-12 d-flex d-lg-none mt-5 flex-wrap gap-3">
                        <a href="#programs"
                           className="btn btn-lg btn-primary d-inline-flex align-items-center gap-2 font-semibold">
                            See Programs <span className="material-symbols-outlined">arrow_forward</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
